import styled from 'styled-components';

/** How much each child overlaps the previous (~half an avatar's width). */
const OVERLAP = '0.55em';

export const SStack = styled.span`
  position: relative;
  display: inline-flex;
  flex: 0 0 auto;
`;

export const SItems = styled.span<{ $depth: number }>`
  display: inline-flex;

  > * + * {
    margin-left: -${OVERLAP};
  }

  /* Earlier items paint on top so the leftmost child is fully visible. */
  ${({ $depth }) =>
    Array.from(
      { length: $depth },
      (_, i) => `> *:nth-child(${i + 1}) { position: relative; z-index: ${$depth - i}; }`
    ).join('\n')}
`;
